import { combineReducers } from "redux";

import auth from "./auth";
import profile from "./profile";
import post from "./post";
import friend from "./friend";
import article from "./article";
import imearticle from "./imearticle";
import vrtour from "./vrtour";
import job from "./job";
import gif from "./gif";
import industryweek from "./industryweek";
import employerweek from "./employerweek";
import notification from "./notification";
import alert from "./alert";
import subscribe from "./subscribe";
import course from "./course";
import setting from "./setting";
import message from "./message";
import discussion from "./discussion";
import report from "./report";
import blockuser from "./blockuser";
import purchase from "./purchase";
import stream from "./stream";
import email from "./email";

export default combineReducers({
  auth,
  profile,
  post,
  friend,
  article,
  imearticle,
  vrtour,
  job,
  gif,
  industryweek,
  employerweek,
  notification,
  alert,
  subscribe,
  course,
  setting,
  message,
  discussion,
  report,
  blockuser,
  purchase,
  stream,
  email,
});
